export const ADMIN_CONFIG = {
  adminPath: '/dash-dz-2026',
  adminPassword: '198577elgolea',
};